export default __webpack_public_path__ + "static/media/clock-icon-bw.f29577da.svg";